import { DomHelpers } from '../DomHelpers.js';

/**
 * Инициализирует поддержку autoresize и символ-счётчика для textarea.
 * Аналог старого jQuery-кода.
 */
function initTextarea(root = document.body) {
    const textareas = root.querySelectorAll('textarea.autoresize, textarea[maxlength]');
    textareas.forEach(textarea => {
        if (textarea.dataset.inited === "1") {
            return; // уже инициализировано
        }
        textarea.dataset.inited = "1";
        // --- autoresize ---
        if (textarea.classList.contains('autoresize')) {
            textarea.style.height = `${textarea.scrollHeight}px`;
            textarea.style.resize = 'none';
            textarea.removeAttribute('rows');
            // отключаем smooth scroll для ближайшего скролл-контейнера
            const scrollParent = DomHelpers.closestScrollParent(textarea);
            if (scrollParent) {
                scrollParent.style.scrollBehavior = 'unset';
            }
        }
        // --- счётчик символов ---
        if (textarea.hasAttribute('maxlength')) {
            const counter = textarea.nextElementSibling?.querySelector('span');
            if (counter) {
                counter.textContent = textarea.value.length.toString();
            }
        }
        // --- обработчики событий ---
        textarea.addEventListener('input', () => updateTextarea(textarea));
        textarea.addEventListener('updateAutoresize', () => updateTextarea(textarea));
    });
    /**
     * Обновляет размеры и счётчик textarea.
     */
    function updateTextarea(el) {
        if (el.classList.contains('autoresize')) {
            const scrollParent = DomHelpers.closestScrollParent(el);
            const prevScrollTop = scrollParent?.scrollTop ?? 0;
            el.style.height = 'auto';
            el.style.height = `${el.scrollHeight}px`;
            if (scrollParent && el.offsetHeight > scrollParent.offsetHeight) {
                scrollParent.scrollTo({ top: prevScrollTop });
            }
        }
        if (el.hasAttribute('maxlength')) {
            const counter = el.nextElementSibling?.querySelector('span');
            if (counter) {
                counter.textContent = el.value.length.toString();
            }
        }
    }
}

export { initTextarea };
